(function () {
  document.querySelectorAll('[data-gw-mix]').forEach((box) => {
    const select = box.querySelector('[data-gw-variant]');
    const btn = box.querySelector('[data-gw-add]');
    btn.addEventListener('click', async () => {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(select.value), quantity: 1 }),
        });
        if (!res.ok) throw new Error('add failed');
        btn.textContent = 'Added';
        setTimeout(() => { btn.textContent = 'Add'; btn.disabled = false; }, 1600);
      } catch (e) {
        btn.textContent = 'Try again';
        btn.disabled = false;
      }
    });
  });
})();
